import React from 'react'
import { Card } from "react-bootstrap";
import { Draggable } from "react-beautiful-dnd";


const getItemStyle = (draggableStyle) => ({
    userSelect: 'none',
    ...draggableStyle,
});

function UserCard(props) {
    const { user, userId, index, onFilter } = props;
    if (!user || !onFilter(user)) return <></>;

    return <Draggable draggableId={`user_${userId}`} index={index} /*   isDropDisabled={!isToday(range)} */>
        {(provided, snapshot) => (
            <div ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={getItemStyle(provided.draggableProps.style)} >
                <Card className={`scout-card `}>
                    <Card.Body>
                        <Card.Title className="text-muted scout-shape-name" title={user.name}>
                            {user.name}
                        </Card.Title>
                    </Card.Body>
                </Card>
            </div>
        )}
    </Draggable>
}

export default UserCard;